import React from "react";
import Footer from "../../common/Footer.js";
import AdminSideNav from "../../common/AdminSideNav.js";
import AnalystSideNav from "../../common/AnalystSideNav.js";
import TopNav from "../../common/TopNav.js";
import requireAuth from "../../hoc/requireAuth.js";
import authorizeAnalystOrAdmin from "../../hoc/authorizeAnalystOrAdmin.js";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2/dist/sweetalert2.js";
import debounce from "lodash.debounce";
import { withAlert } from "react-alert";
import { connect } from "react-redux";
import { castToISTDefaultDateFormat, castToISTTimeFormat } from "../../settings/index";

class Scrapper1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      platform: "",
      filename: "",
      emailId: "",
      formSubmitted: false,
      queues: [],
      pagination: {
        page: 1,
        nextPage: 2,
        prevPage: null,
        hasNextPage: true,
        hasPrevPage: false,
        totalDocs: null,
      },
      perPage: 10,
      isLoading: false,
      hasMoreDomainData: true,
    };
    this.fileInputRef = React.createRef();
    this.listofRecords = debounce(this.listofRecords.bind(this), 500);

    window.onscroll = debounce(() => {
      const { hasMoreDomainData } = this.state;
      if (!hasMoreDomainData || this.state.isLoading) return;

      if (
        window.innerHeight + document.documentElement.scrollTop >=
        document.documentElement.offsetHeight - 100
      ) {
        this.listofRecords();
      }
    }, 100);
  }

  componentDidMount() {
    this.getEmailId();
    this.listofRecords(true);
  }

  getEmailId = async () => {
    try {
      const res = await window.axios.get("/users/getEmailId");
      this.setState({ emailId: res.data.data });
    } catch (error) {
      this.props.alert.error("Failed to fetch email");
      console.error("Email fetch error:", error);
    }
  };

  saveScrapper1Data = async (e) => {
    e.preventDefault();
    const { platform, filename, emailId } = this.state;
    const file = this.fileInputRef.current?.files[0];

    if (!platform || !filename || !emailId || !file) {
      this.setState({ formSubmitted: true });
      this.props.alert.error("Please fill all required fields");
      return;
    }

    const validTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
    ];
    if (!validTypes.includes(file.type)) {
      this.props.alert.error("Invalid file type. Please upload an Excel file");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      this.props.alert.error("File size too large (max 5MB)");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("filename", filename);
    formData.append("platform", platform);
    formData.append("email", emailId);

    try {
      await window.axios.post("/gateway/scraper1/api/queue", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      this.props.alert.success("New Entries added!");
      this.setState({ platform: "", filename: "", formSubmitted: false });
      if (this.fileInputRef.current) this.fileInputRef.current.value = "";
      this.listofRecords(true);
    } catch (error) {
      console.error("Upload error:", error);
      let errorMessage = "File upload failed";

      if (error.response) {
        errorMessage = error.response.data?.message || errorMessage;
        if (error.response.status === 422) {
          this.setState({ errorMessage: error.response.data.errors });
        }
      }
      this.props.alert.error(errorMessage);
    }
  };

  listofRecords = async (reset = false) => {
    if (this.state.isLoading) return;

    this.setState({ isLoading: true });
    try {
      const params = {
        page: reset ? 1 : this.state.pagination.nextPage,
        limit: this.state.perPage,
      };

      const { data } = await window.axios.get("/gateway/scraper1/api/queue", {
        params,
      });
      const { result, total, page, totalPages, data: resultData } = data;

      if (result <= 0) {
        this.setState({ isLoading: false, ...(reset && { queues: [] }) });
        return;
      }

      const hasNextPage = page < totalPages;
      const nextPage = hasNextPage ? page + 1 : null;

      this.setState((prevState) => ({
        queues: reset ? resultData : [...prevState.queues, ...resultData],
        isLoading: false,
        hasMoreDomainData: hasNextPage,
        pagination: {
          ...prevState.pagination,
          page,
          nextPage,
          hasNextPage,
          totalDocs: total,
          totalPages,
        },
      }));
    } catch (error) {
      console.error("Fetch error:", error);
      this.setState({ isLoading: false });
      this.props.alert.error("Failed to load records");
    }
  };

  deleteRecord = async (id) => {
    const result = await Swal.fire({
      title: "Delete Record?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Delete",
    });

    if (result.isConfirmed) {
      try {
        await window.axios.delete(`/gateway/scraper1/api/queue/${id}`);
        this.props.alert.success("Record deleted");
        this.listofRecords(true);
      } catch (error) {
        console.error("Delete error:", error);
        this.props.alert.error("Failed to delete record");
      }
    }
  };

  renderContent() {
    const { platform, filename, emailId, formSubmitted, queues, isLoading } =
      this.state;

    return (
      <div className="col">
              <div className="card card-small mb-4">
                <div className="card-body">
                  <form onSubmit={this.saveScrapper1Data}>
                    <div className="row">
                      <div className="col-md-3">
                        <label className="form-label">Filename</label>
                        <input
                          type="text"
                          className="form-control"
                          value={filename}
                          onChange={(e) =>
                            this.setState({ filename: e.target.value })
                          }
                          required
                        />
                        {formSubmitted && !filename && (
                          <div className="text-danger">Required field</div>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Platform</label>
                        <select
                          className="form-control"
                          value={platform}
                          onChange={(e) =>
                            this.setState({ platform: e.target.value })
                          }
                          required
                        >
                          <option value="">Select Platform</option>
                          <option value="website">Website</option>
                          <option value="social-media">Social Media</option>
                          <option value="e-commerce">E-commerce</option>
                          <option value="app-store">App Store</option>
                        </select>
                        {formSubmitted && !platform && (
                          <div className="text-danger">Required field</div>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          value={emailId}
                          onChange={(e) =>
                            this.setState({ emailId: e.target.value })
                          }
                          readOnly
                        />
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">
                          Excel File (XLSX/XLS)
                        </label>
                        <input
                          type="file"
                          className="form-control"
                          ref={this.fileInputRef}
                          accept=".xlsx, .xls"
                          required
                        />
                        {formSubmitted && !this.fileInputRef.current?.files[0] && (
                          <div className="text-danger">File required</div>
                        )}
                      </div>

                      <div className="col-md-3 mt-2 d-flex gap-3">
                        <button
                          type="submit"
                          className="btn btn-success"
                          disabled={isLoading}
                        >
                          {isLoading ? "Uploading..." : "Upload File"}
                        </button>

                        <button
                          role="button"
                          type="button"
                          className="btn btn-dark"
                          onClick={() => this.listofRecords(true)}
                        >
                          Sync
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="container-fluid px-0 mx-0">
                <div className="card shadow-sm border-0 px-0 mx-0">
                  <div className="card-header bg-white border-bottom d-flex justify-content-between align-items-center py-3">
                    <h6 className="m-0 font-weight-bold text-primary">
                      <i className="fas fa-history mr-2"></i>
                      Upload History
                      <small className="text-muted ml-2">
                        Last updated: {new Date().toLocaleString()}
                      </small>
                    </h6>
                    <span className="badge badge-primary badge-pill">
                      {this.state.pagination?.totalDocs || 0} records
                    </span>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead className="thead-light">
                          <tr>
                            <th scope="col" className="pl-4">
                              #
                            </th>
                            <th scope="col">Date Added</th>
                            <th scope="col">Username</th>
                            <th scope="col">Filename</th>
                            <th scope="col">Platform</th>
                            <th scope="col">Records</th>
                            <th scope="col">Status</th>
                            <th scope="col" className="text-center">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {queues.length > 0 ? (
                            queues.map((queue, index) => (
                              <tr key={queue.id}>
                                <td className="pl-4 text-muted">{index + 1}</td>
                                <td>
                                  <div className="d-flex flex-column">
                                    <small className="text-muted">
                                      {castToISTDefaultDateFormat(queue.createdAt)}
                                    </small>
                                    <small>
                                      {castToISTTimeFormat(queue.createdAt)}
                                    </small>
                                  </div>
                                </td>
                                <td>
                                  <span
                                    className="text-nowrap d-inline-block"
                                    style={{ maxWidth: "120px" }}
                                    title={queue.receiverEmail}
                                  >
                                    {queue.receiverEmail}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    <i className="far fa-file-alt text-muted mr-2"></i>
                                    <span
                                      className="text-truncate d-inline-block"
                                      style={{ maxWidth: "150px" }}
                                      title={queue.fileName}
                                    >
                                      {queue.fileName}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span className="text-truncate d-inline-block">
                                    {queue.platform}
                                  </span>
                                </td>
                                <td>
                                  <span className="font-weight-bold">
                                    {queue.numOfRecords}
                                  </span>
                                </td>
                                <td>
                                  <span
                                    className={`badge badge-pill ${
                                      queue.status === "processed"
                                        ? "bg-success"
                                        : queue.status === "failed"
                                          ? "bg-danger"
                                          : queue.status === "processing"
                                            ? "bg-info"
                                            : "bg-warning"
                                    }`}
                                  >
                                    {queue.status.charAt(0).toUpperCase() +
                                      queue.status.slice(1)}
                                  </span>
                                </td>
                                <td className="text-center">
                                  {(() => {
                                    const isDisabled = queue.status !== "queued";
                                    return (
                                      <button
                                        className={`btn btn-sm ${
                                          isDisabled
                                            ? "btn-outline-secondary"
                                            : "btn-outline-danger"
                                        }`}
                                        onClick={() =>
                                          this.deleteRecord(queue._id)
                                        }
                                        title="Delete record"
                                        disabled={isDisabled}
                                      >
                                        <i
                                          className={`fas fa-trash-alt ${
                                            isDisabled ? "text-muted" : ""
                                          }`}
                                        ></i>
                                      </button>
                                    );
                                  })()}
                                </td>
                              </tr>
                            ))
                          ) : this.state.isLoading ? (
                            <tr>
                              <td colSpan="8" className="text-center py-4">
                                <div className="py-5">
                                  <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                  <Loader
                                    type="ThreeDots"
                                    color="#00BFFF"
                                    height={30}
                                    width={30}
                                  />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center py-4">
                                <div className="py-5">
                                  <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
                                  <p className="text-muted">
                                    No records available
                                  </p>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              {this.state.hasMoreDomainData && (
                <div className="text-center my-4">
                  {!this.state.isLoading && (
                    <button
                      className="btn btn-outline-primary"
                      onClick={() => this.listofRecords()}
                    >
                      Load More
                    </button>
                  )}
                </div>
              )}
      </div>
    );
  }

  render() {
    if (this.props.embedded) return this.renderContent();

    const login = this.props.login;
    return (
      <div className="row">
        {login?.user?.role === "Admin" ? <AdminSideNav /> : <AnalystSideNav />}
        <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
          <TopNav />
          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-4">
              <div className="col-12">
                <span className="text-uppercase page-subtitle">SCRAPPER 1</span>
              </div>
            </div>
            {this.renderContent()}
          </div>
          <Footer />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeAnalystOrAdmin(requireAuth(Scrapper1))),
);
